/**
 * Design System Tokens
 * Centralized export of all design tokens
 * Single source of truth for colors, typography, spacing, shadows, motion, and radius
 */

export { colors } from './colors';
export { typography } from './typography';
export { spacing } from './spacing';
export { shadows } from './shadows';
export { motion, keyframes, createAnimation, staggerDelay, entranceAnimation, staggeredEntrance, hoverTransition, smoothTransition } from './motion';
export { radius } from './radius';
export { generateCSSVariables, glassmorphism, gradient, focusRing, truncate, centerContent } from './css-utilities';

import { colors } from './colors';
import { typography } from './typography';
import { spacing } from './spacing';
import { shadows } from './shadows';
import { motion } from './motion';
import { radius } from './radius';

/**
 * Unified tokens object
 * Access all tokens through this object: tokens.colors, tokens.typography, etc.
 */
export const tokens = {
  colors,
  typography,
  spacing,
  shadows,
  motion,
  radius,
};

export type DesignTokens = typeof tokens;
